import React from 'react';
import PropTypes from 'prop-types';

const Link = (props) => {
  const {
    href,
    title = '',
    children,
    forceDangerousRendering = false,
    ...rest
  } = props;

  if (!href) {
    return null;
  }

  const linkProps = { href, ...rest };

  // TODO - filter list of props sent to anchor tag
  /* eslint-disable react/jsx-props-no-spreading */
  return title || forceDangerousRendering
    ? <a aria-label={title || href} {...linkProps} dangerouslySetInnerHTML={{ __html: title }} />
    : <a aria-label={title || href} {...linkProps}>{children}</a>;
  /* eslint-enable react/jsx-props-no-spreading */
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  forceDangerousRendering: PropTypes.bool,
};

export default Link;
